<script lang="ts">
	import classNames from 'classnames';
	import { getImageUrl } from '../../../utils/getImageUrl';
	import { Hero } from '../../Hero';
	import type { DropHero as DropHeroType } from './types';

	interface Props {
		pastDropPage: boolean;
		dataCy: string;
		item: DropHeroType;
		showCardButtons: boolean;
		showCardCartButton: boolean;
		enforcedDesktopImage?: string | null;
		enforcedMobileImage?: string | null;
		heroClasses?: Record<string, string>;
	}

	let {
		pastDropPage,
		dataCy,
		item,
		showCardButtons,
		showCardCartButton,
		enforcedDesktopImage,
		enforcedMobileImage,
		heroClasses = {}
	}: Props = $props();

	let textShadow = $derived(!!item.text_shadow);

	let desktopImage = $derived(
		enforcedDesktopImage || getImageUrl(item?.image?.filename_disk, '2048px')
	);

	let mobileImage = $derived(
		enforcedMobileImage || getImageUrl(item?.mobile_image?.filename_disk, '2048px')
	);

	let desktopImageStyle = $derived(
		item.desktop_image_zoom ||
			(item.desktop_image_position_x !== null && item.desktop_image_position_x !== undefined) ||
			(item.desktop_image_position_y !== null && item.desktop_image_position_y !== undefined)
			? `transform: scale(${item.desktop_image_zoom || 1}); transform-origin: ${item.desktop_image_position_x ?? 50}% ${item.desktop_image_position_y ?? 50}%;`
			: undefined
	);

	let mobileImageStyle = $derived(
		item.mobile_image_zoom ||
			(item.mobile_image_position_x !== null && item.mobile_image_position_x !== undefined) ||
			(item.mobile_image_position_y !== null && item.mobile_image_position_y !== undefined)
			? `transform: scale(${item.mobile_image_zoom || 1}); transform-origin: ${item.mobile_image_position_x ?? 50}% ${item.mobile_image_position_y ?? 50}%;`
			: undefined
	);
</script>

<Hero
	align="center"
	layerOpacity={[null, undefined].includes(item.layer_opacity as null | undefined)
		? 0.1
		: item.layer_opacity}
	mobileSrc={mobileImage}
	overline={item.label_4}
	highResolution={!item?.image_compressed}
	buttonProps={(() => {
		if (pastDropPage && item.inactive_label_button_text && item.inactive_label_button_url) {
			return {
				label: item.inactive_label_button_text,
				href: item.inactive_label_button_url
			};
		}

		if (showCardButtons) {
			const label =
				!showCardCartButton && item.inactive_label_button_text
					? item.inactive_label_button_text
					: item.label_button_text;

			const href =
				!showCardCartButton && item.inactive_label_button_text
					? item.inactive_label_button_url
					: item.label_button_url;

			if (label && href) {
				return {
					variant: 'secondary',
					label,
					href
				};
			}

			return undefined;
		}

		return undefined;
	})()}
	src={desktopImage}
	title={item?.title || ''}
	alt={item?.title || ''}
	subtitle={item?.subtitle}
	{textShadow}
	{desktopImageStyle}
	{mobileImageStyle}
	class="h-[50vh]"
	classes={{
		button: classNames({ 'hidden lg:block': item.hide_button_on_mobile }),
		...heroClasses,
		...(item.large_font && {
			title: 'text-[3rem] sm:text-[4rem]',
			subtitle: 'text-[1.75rem] sm:text-[2.25rem]'
		}),
		overline: 'uppercase mb-6 tracking-[1.6px]'
	}}
	{dataCy}
/>
